__turbopack_context__.v({
  "condition-item": "password-card-module-scss-module__KZJy9a__condition-item",
  "conditions": "password-card-module-scss-module__KZJy9a__conditions",
  "footer": "password-card-module-scss-module__KZJy9a__footer",
  "info": "password-card-module-scss-module__KZJy9a__info",
  "input": "password-card-module-scss-module__KZJy9a__input",
  "otp-error": "password-card-module-scss-module__KZJy9a__otp-error",
  "pass": "password-card-module-scss-module__KZJy9a__pass",
  "title": "password-card-module-scss-module__KZJy9a__title",
});
